












import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class HubSpotForm extends Vue {
  @Prop() portalId!: String;
  @Prop() region!: String;
  @Prop() formId!: String;
  @Prop() preStyled!: Boolean;

  styleConfig = {
    cssClass: "hubspotform",
    errorMessageClass: "hubspotform-errors",
    submitButtonClass: `
      hubspotform-submit
      v-btn v-btn--depressed
      v-btn--flat v-btn--outlined
      theme--dark v-size--default
    `
  };

  mounted() {
    if (this.hasHubSpotFormLibrary) {
      this.mountForm();
    }
  }

  mountForm() {
    (window as any).hbspt.forms.create(this.formConfig);
  }

  get formConfig() {
    if (this.isPreStyled) {
      return this.baseFormConfig;
    } else {
      return {
        ...this.baseFormConfig,
        ...this.styleConfig
      };
    }
  }

  get baseFormConfig() {
    return {
      region: this.region,
      portalId: this.portalId,
      formId: this.formId,
      target: `#${this.htmlFormId}`
    };
  }

  get hasHubSpotFormLibrary() {
    return !!(window as any).hbspt;
  }

  get htmlFormId() {
    return `hsform-${this.formId}`;
  }

  get isPreStyled() {
    return !!this.preStyled;
  }
}
